import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { inject } from 'helpers/mobx'
import { getCanonicalFromHreflangs } from 'helpers/seo'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import React, { FC } from 'react'

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default inject(store => {
  const t = store.t
  const title = t('Modemarken Übersicht - ABOUT YOU')
  const description = t(
    'Marken bei ABOUT YOU - Mode von vielen Marken versandkostenfrei online kaufen. Schnelle Lieferzeit und {{returnDays}} Tagen Rückgaberecht für deine Top Marken.',
    {
      returnDays: store.configStore.returnDays,
    },
  )
  const { locale } = store.localeStore
  const links = store.brandOverviewPageStore.hreflangs
  const canonicalUrl = getCanonicalFromHreflangs({ hreflangs: links, locale })

  return {
    title,
    description,
    renderHreflangs: true,
    customTitleTemplate: true,
    links,
    canonicalUrl,
  }
})(DocumentHead)
